
import angular from 'angular';


const controllerInfo = {
    module: 'ib-ancillaries-modal-module',
    inject: ['object', '$uibModalInstance'],
    required: []
};

export class PriorityWarningChildController implements ng.IController {

    public model;
    constructor (
        private object: any,
        private $uibModalInstance: ng.ui.bootstrap.IModalInstanceService) {
        this.model = object;
    }

    /**
        * Close modal
        */
    close = (): void => {
        angular.element(document).find('.modal').eq(0).removeClass('ib-modals--outside');
        this.$uibModalInstance.dismiss('cancel');
    };

    // $uibModalInstance.result.catch(() => {
    //     angular.element(document).find('.modal').eq(0).removeClass('ib-modals--outside');
    //     $uibModalInstance.close();
    // });
}


try {
    PriorityWarningChildController.$inject = controllerInfo.inject;
    angular.module(controllerInfo.module).controller(PriorityWarningChildController.name, PriorityWarningChildController);

} catch (error) {
    const mod = angular.module(controllerInfo.module, controllerInfo.required);
    PriorityWarningChildController.$inject = controllerInfo.inject;
    mod.controller(PriorityWarningChildController.name, PriorityWarningChildController);
}